import { pipe } from "fp-ts/lib/function";
import * as t from "io-ts";
import * as E from "fp-ts/lib/Either";

interface Base64Brand {
  readonly Base64Brand: unique symbol;
}

export type Base64C = t.Type<t.Branded<string, Base64Brand>, string, unknown>

function isBase64(value: string) {
  try {
    Buffer.from(value, "base64");
    return true;
  } catch {
    return false;
  }
}

export const Base64: Base64C = new t.Type<t.Branded<string, Base64Brand>, string, unknown>(
  'Base64',
  (u): u is t.Branded<string, Base64Brand> => typeof u === "string" && isBase64(u),
  (u, c) =>
    pipe(
      t.string.validate(u, c),
      E.chain(s => {
        return isBase64(s) ? t.success(s as t.Branded<string, Base64Brand>) : t.failure(u, c);
      })
    ),
  a => a
);
export type Base64 = t.TypeOf<typeof Base64>;

interface Base64UrlBrand {
  readonly Base64UrlBrand: unique symbol;
}

export type Base64UrlC = t.Type<t.Branded<string, Base64UrlBrand>, string, unknown>

function isBase64Url(value: string) {
  try {
    Buffer.from(value.replace(/_/g, '/').replace(/-/g, '+'), "base64");
    return true;
  } catch {
    return false;
  }
}

export const Base64Url: Base64UrlC = new t.Type<t.Branded<string, Base64UrlBrand>, string, unknown>(
  'Base64Url',
  (u): u is t.Branded<string, Base64UrlBrand> => typeof u === "string" && isBase64Url(u),
  (u, c) =>
    pipe(
      t.string.validate(u, c),
      E.chain(s => {
        return isBase64Url(s) ? t.success(s as t.Branded<string, Base64UrlBrand>) : t.failure(u, c);
      })
    ),
  a => a
);
export type Base64Url = t.TypeOf<typeof Base64Url>;
